import { Star } from 'lucide-react'

import { cn } from '@/_lib/utils'

/**
 * Five stars with full / half / empty derived from a 0–5 rating (e.g. Google overall 4.5).
 */
export default function AHomeGoogleRatingStars({
	rating,
	className,
	size = 28
}: {
	rating: number
	className?: string
	size?: number
}) {
	const clamped = Math.min(Math.max(rating, 0), 5)

	return (
		<div className={cn('flex items-center gap-0.5', className)} aria-hidden>
			{Array.from({ length: 5 }, (_, i) => {
				const fraction = Math.min(Math.max(clamped - i, 0), 1)
				return (
					<span
						key={i}
						className='relative inline-flex shrink-0'
						style={{ width: size, height: size }}
					>
						<Star
							size={size}
							className='text-neutral-300'
							strokeWidth={1.5}
							fill='transparent'
						/>
						{fraction > 0 ? (
							<span
								className='pointer-events-none absolute inset-y-0 left-0 overflow-hidden'
								style={{ width: `${fraction * 100}%` }}
							>
								<Star
									size={size}
									className='fill-amber-500 text-amber-500'
									strokeWidth={1.5}
								/>
							</span>
						) : null}
					</span>
				)
			})}
		</div>
	)
}
